module.exports = __webpack_public_path__ + "media/images/share-send-9b7f34de242aede1b6a2d97c2a996967.svg";